(function () {
  const LOCALE = 'fr-FR';
  const TZ = 'Europe/Paris';

  function formatDateFR(date) {
    // Format: mardi 12 mars
    return new Intl.DateTimeFormat(LOCALE, {
      timeZone: TZ,
      weekday: 'long',
      day: '2-digit',
      month: 'long',
    }).format(date);
  }

  function addBusinessDays(date, days) {
    const d = new Date(date);
    let added = 0;

    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay(); // 0=dim, 6=sam
      if (day !== 0 && day !== 6) added += 1;
    }
    return d;
  }

  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function nextBusinessDay(date) {
    const d = new Date(date);
    while (isWeekend(d)) d.setDate(d.getDate() + 1);
    return d;
  }

  function getParisNow() {
    // On reconstruit une date "now" cohérente Europe/Paris
    // (sans lib externe, c’est une approximation suffisante pour cutoff)
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(new Date());

    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return new Date(`${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}`);
  }

  function initDeliveryBlock(root) {
    const blocks = root.querySelectorAll('[data-delivery-estimate]');
    blocks.forEach((block) => {
      const textEl = block.querySelector('[data-delivery-text]');
      const cfg = block.querySelector('.gyl-delivery__config');

      if (!textEl || !cfg) return;

      const minDays = parseInt(cfg.dataset.minDays || '2', 10);
      const maxDays = parseInt(cfg.dataset.maxDays || '4', 10);
      const cutoffHour = parseInt(cfg.dataset.cutoffHour || '13', 10);

      const nowParis = getParisNow();
      let shipBase = new Date(nowParis);

      // Si weekend -> prochain jour ouvré
      shipBase = nextBusinessDay(shipBase);

      // cutoff: si après Xh, expédition base = prochain jour ouvré
      if (nowParis.getHours() >= cutoffHour) {
        shipBase = addBusinessDays(shipBase, 1);
      }

      // Fenêtre de livraison (jours ouvrés à partir de l'expédition)
      const etaMin = addBusinessDays(shipBase, minDays);
      const etaMax = addBusinessDays(shipBase, maxDays);

      const minStr = formatDateFR(etaMin);
      const maxStr = formatDateFR(etaMax);

      const minStrFormatted = '<strong>' + minStr + '</strong>';
      const maxStrFormatted = '<strong>' + maxStr + '</strong>';

      textEl.innerHTML = `Entre le ${minStrFormatted} et le ${maxStrFormatted}`;
    });
  }

  document.addEventListener('DOMContentLoaded', () => initDeliveryBlock(document));
  document.addEventListener('shopify:section:load', (e) => initDeliveryBlock(e.target));
})();